// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"3ab4f0de","184":"47f979ac","280":"3e227cad","426":"5a9d56a4"}[chunkId] + ".chunk.js";
};